import {Injectable} from '@angular/core';
import {EntityState, SignalEntityStore} from '../../state/signal-entity.store';
import {ShoppingCartItem} from '../../models/underwriter.model';

export interface ShoppingCartState extends EntityState<ShoppingCartItem>{}

@Injectable({providedIn: 'root'})
export class ShoppingCartStore extends SignalEntityStore<ShoppingCartItem, ShoppingCartState> {
    constructor() {
        super({name: 'shopping-cart', idKey: 'shoppingcart_id'});
    }
}
